/* 
 * RectangleTransition.js
 * Created on 7-apr-2017
 * @author Swen Meeuwes for &ranj
 */

import AnimationOptions from "../AnimationOptions";
import AnimationFactory from "../AnimationFactory";

export default class RectangleTransition {
    constructor(type) {
        this.type = type;
    };

    animate(screenNavigator, screen, animationOptions) {
        return new Promise(function (resolve, reject) {
            // If no animation options are specified, use the default animation options
            if (animationOptions === undefined)
                animationOptions = new AnimationOptions();

            var beginRectangleScale = { scaleX: 0, scaleY: 0 };
            var endRectangleScale = { scaleX: 0, scaleY: 0 };

            switch (this.type) {
                case AnimationFactory.RECTANGLE_IN:
                    beginRectangleScale.scaleX = beginRectangleScale.scaleY = 0;
                    endRectangleScale.scaleX = endRectangleScale.scaleY = 1;
                    break;
                case AnimationFactory.RECTANGLE_OUT:
                    beginRectangleScale.scaleX = beginRectangleScale.scaleY = 1;
                    endRectangleScale.scaleX = endRectangleScale.scaleY = 0;
                    break;
                default:
                    // Log warning
                    break;
            }

            // Create a rectangle shape to act as a mask
            var rectangleGraphics = new createjs.Graphics();
            rectangleGraphics.beginFill("#0F0").drawRect(0, 0, screenNavigator.getScreenWidth(), screenNavigator.getScreenHeight());
            var rectangle = new createjs.Shape(rectangleGraphics);
            rectangle.regX = screenNavigator.getScreenWidth() / 2;
            rectangle.regY = screenNavigator.getScreenHeight() / 2;
            rectangle.x = screenNavigator.getScreenWidth() / 2;
            rectangle.y = screenNavigator.getScreenHeight() / 2;

            // Set the circle to its begin size
            rectangle.set(beginRectangleScale);

            // Mask the screen with the circle shape
            screen.mask = rectangle;

            // Execute the tween with the given animation options
            createjs.Tween
                .get(rectangle)
                .wait(animationOptions.delay)
                .to(endRectangleScale, animationOptions.duration, animationOptions.ease)
                .call(function () {
                    // Handle callbacks in animation options
                    if (animationOptions.callbacks)
                        for (var i = 0; i < animationOptions.callbacks.length; i++) {
                            animationOptions.callbacks[i].call(this);
                        }
                    resolve();
                }.bind(this));
        }.bind(this));
    };
}